export const CONTACT_ADMIN = "CONTACT_ADMIN"
export const CONTACT_ADMIN_SUCCESS = "CONTACT_ADMIN_SUCCESS"
export const CONTACT_ADMIN_FAILED = "CONTACT_ADMIN_FAILED"